import { render } from "./AdTypeTableItem.vue?vue&type=template&id=afbb8b02"
import script from "./AdTypeTableItem.vue?vue&type=script&lang=js"
export * from "./AdTypeTableItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__